import { type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/pages/IndexPage.vue'),
        meta: { requiresAuth: true, title: 'Dashboard' },
      },
      {
        path: 'business/:id?',
        name: 'Business',
        component: () => import('@/pages/BusinessPage.vue'),
        meta: { requiresAuth: true, title: 'Business' },
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/pages/LoginPage.vue'),
        meta: { requiresAuth: false, title: 'Login' },
      },
      {
        path: 's/:id/c/',
        name: 'ConfirmAppointment',
        component: () => import('@/pages/AppointmentActionPage.vue'),
        meta: { requiresAuth: false, title: 'Confirm Appointment' },
      },
      {
        path: 's/:id/r/',
        name: 'RejectAppointment',
        component: () => import('@/pages/AppointmentActionPage.vue'),
        meta: { requiresAuth: false, title: 'Cancel Appointment' },
      },
      {
        path: 's/:id/',
        name: 'AppointmentAction',
        component: () => import('@/pages/AppointmentActionPage.vue'),
        meta: { requiresAuth: false, title: 'Confirm or Cancel Appointment' },
      },

      {
        path: 'wo/:id/a/',
        name: 'ApproveWorkOrderPrice',
        component: () => import('@/pages/WorkOrderApprovalPage.vue'),
        meta: { requiresAuth: false, title: 'Approve Work Order Price' },
      },
      {
        path: 'wo/:id/r/',
        name: 'RejectWorkOrderPrice',
        component: () => import('@/pages/WorkOrderApprovalPage.vue'),
        meta: { requiresAuth: false, title: 'Reject Work Order Price' },
      },
      {
        path: 'wo/:id/',
        name: 'WorkOrderApproval',
        component: () => import('@/pages/WorkOrderApprovalPage.vue'),
        meta: { requiresAuth: false, title: 'Approve or Reject Work Order Price' },
      },

      {
        path: 'damage-reports',
        name: 'DamageReports',
        component: () => import('@/pages/DamageReportsPage.vue'),
        meta: { requiresAuth: true, title: 'Damage Reports' },
      },
      {
        path: 'work-orders',
        name: 'WorkOrders',
        component: () => import('@/pages/WorkOrdersPage.vue'),
        meta: { requiresAuth: true, title: 'Work Orders' },
      },
      {
        path: 'bikes',
        name: 'Bikes',
        component: () => import('@/pages/BikesPage.vue'),
        meta: { requiresAuth: true, title: 'Bikes' },
      },
      {
        path: 'part-reports',
        name: 'PartReports',
        component: () => import('@/pages/PartReportsPage.vue'),
        meta: { requiresAuth: true, title: 'Part Reports' },
      },
      {
        path: 'bookings',
        name: 'Bookings',
        component: () => import('@/pages/BookingsPage.vue'),
        meta: { requiresAuth: true, title: 'Bookings' },
      },
      {
        path: 'scheduledstops',
        name: 'ScheduledStops',
        component: () => import('@/pages/ScheduledStopsPage.vue'),
        meta: { requiresAuth: true, title: 'Scheduled Stops' },
      },
      {
        path: 'api-keys',
        name: 'ApiKeys',
        component: () => import('@/pages/ApiKeysPage.vue'),
        meta: { requiresAuth: true, title: 'API Keys' },
      },
      {
        path: 'exports',
        name: 'Exports',
        component: () => import('@/pages/ExportTemplatesPage.vue'),
        meta: { requiresAuth: true, title: 'Data Exports' },
      },
      {
        path: 'notification-settings',
        name: 'NotificationSettings',
        component: () => import('@/pages/NotificationSettingsPage.vue'),
        meta: { requiresAuth: true, title: 'Notification Settings' },
      },
      {
        path: 'integrations',
        name: 'Integrations',
        component: () => import('@/pages/IntegrationsPage.vue'),
        meta: { requiresAuth: true, title: 'Integrations' },
      },
      {
        path: 'integrations/fleetio',
        name: 'FleetioIntegration',
        component: () => import('@/pages/FleetioIntegrationPage.vue'),
        meta: { requiresAuth: true, title: 'Fleetio Integration' },
      },
      {
        path: 'integrations/bumbal',
        name: 'BumbalIntegration',
        component: () => import('@/pages/BumbalIntegrationPage.vue'),
        meta: { requiresAuth: true, title: 'Bumbal Integration' },
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('@/pages/ErrorNotFound.vue'),
  },
]

export default routes
